<template>
  <div class="kanban-board">
    <Filters
      :users="users"
      :projects="projects"
      :showNoUser="true"
      :showSearch="true"
      :noUserLabel="'Unassigned'"
      @select="updateFilters"
      ref="filters"
    />
    <TaskAdder
      v-if="canAdd"
      :workers="workers"
      :projects="projects"
      @submit="addTask"
    />
    <div class="row">
      <KanbanColumn
        v-for="column in columns"
        :taskStatus="column.taskStatus"
        :title="column.title"
        :tasks="tasksByStatus(column.taskStatus)"
        :key="column.taskStatus"
        :workers="workers"
      />
    </div>
  </div>
</template>

<script>
 import Filters from './work-logs/Filters';
 import TaskAdder from './kanban/TaskAdder';
 import KanbanColumn from './KanbanColumn';
 import Vue from 'vue';
 import axios from 'axios';
 import eventBus from './kanban/event-bus';
 import fuzzySearch from '../fuzzy-search';
 import {showError} from 'perform-base/js/flashes';

 export default {
   components: {
     Filters,
     TaskAdder,
     KanbanColumn,
   },

   created() {
     this.loadItems(() => {
       Vue.nextTick(() => {
         this.$refs.filters.updateFromCookie();
       });
     });

     eventBus.$on('update-task-status', this.updateStatus);
     eventBus.$on('assign-task', this.assignTask);
   },

   props: [
     'canAdd',
   ],

   data() {
     return {
       columns: [
         {
           title: 'Open',
           taskStatus: 0,
         },
         {
           title: 'In Progress',
           taskStatus: 1,
         },
         {
           title: 'In Review',
           taskStatus: 2,
         },
         {
           title: 'Done',
           taskStatus: 3,
         },
       ],
       tasks: [],
       users: [],
       projects: [],
       workers: [],
       selectedUsers: [],
       selectedProjects: [],
       searchTerm: "",
       loading: false,
     }
   },

   computed: {
     tasksByStatus() {
       return (status) => {
         return this.filteredTasks.filter(task => task.status === status);
       }
     },
     filteredTasks() {
       return this.tasks.filter((task) => {
         if (!task.assignee) {
           if (this.selectedUsers.indexOf(-1) === -1) {
             // unassigned
             return false;
           }
         } else {
           if (this.selectedUsers.indexOf(task.assignee.id) === -1) {
             return false;
           }
         }
         if (this.selectedProjects.indexOf(task.project.id) === -1) {
           return false;
         }
         if (this.searchTerm.length < 2) {
           return true;
         }
         if (!fuzzySearch(this.searchTerm, "T" + task.taskNumber + " " + task.title)) {
           return false;
         }
         return true;
       });
     },
   },

   methods: {
     loadItems(cb) {
       this.loading = true;

       axios
         .get('/api/tasks')
         .then(response => {
           this.tasks = response.data.tasks;
           this.users = response.data.users;
           this.projects = response.data.projects;
           this.workers = response.data.workers;
           if (cb) {
             cb();
           }
         }).catch((error) => {
           console.error(error);
           showError('An error occurred fetching tasks. Please reload the page to try again.');
         }).finally(() => {
           this.loading = false;
         });
     },
     updateStatus(data) {
       let taskToUpdate = data.task;
       axios
       .post('/api/tasks/set-status/' + taskToUpdate.id + '/'+ data.status)
       .then(response => {
         this.tasks = this.tasks.map(task => {
           if (task.id === taskToUpdate.id) {
             return Object.assign({}, task, {status: data.status});
           }
           return task;
         });
       })
       .catch((error) => {
         console.error(error);
         showError('An error occurred updating this task. Please reload the page to try again.');
         }).finally(() => {
           this.loading = false;
         });
     },
     assignTask(data) {
       let taskToUpdate = data.task;
       const url = data.assignee ?
                   '/api/tasks/assign/' + taskToUpdate.id + '/'+ data.assignee.id :
                   '/api/tasks/unassign/' + taskToUpdate.id;
       axios
         .post(url)
         .then(response => {
           this.tasks = this.tasks.map(task => {
             if (task.id === taskToUpdate.id) {
               return Object.assign({}, task, {assignee: data.assignee});
             }
             return task;
           });
         }).catch((error) => {
           console.error(error);
           showError('An error occurred updating this task. Please reload the page to try again.');
         }).finally(() => {
           this.loading = false;
         });
     },
     updateFilters(data) {
       this.selectedUsers = data.users;
       this.selectedProjects = data.projects;
       this.searchTerm = data.searchTerm;
     },
     addTask(data) {
       return axios
         .post('/api/tasks/create', data)
         .then(response => {
           this.tasks.unshift(response.data.task);
         }).catch(() => {
           showError('An error occurred creating this task. Try again later.');
         });
     }
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/KanbanBoard.vue